/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PermissionCheckResultDto } from '../models/PermissionCheckResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PermissionsService {

    /**
     * Check current user's permission on an entity
     * @returns PermissionCheckResultDto Successfully retrieved permission check result
     * @throws ApiError
     */
    public static checkEntityPermission({
        entityType,
        entityId,
        requiredRole,
    }: {
        entityType: 'DATASET' | 'DASHBOARD' | 'DAG' | 'TRANSFORMATION' | 'DECLARED_ASSET' | 'DATASET_FIELD' | 'SIFFLET_RULE' | 'INCIDENT' | 'RULE_RUN' | 'DATAPOINT_QUALIFICATION' | 'RULE_MONITORING_RECOMMENDATION' | 'DATA_PRODUCT' | 'NOTIFICATION_RULE',
        entityId: string,
        requiredRole: 'Editor' | 'Monitor responder' | 'Catalog editor' | 'Viewer',
    }): CancelablePromise<PermissionCheckResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/permissions',
            query: {
                'entityType': entityType,
                'entityId': entityId,
                'requiredRole': requiredRole,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
